/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import { Slider, Tag } from 'antd';
import { getLinkProduct, formatNumber, getProfileAfterPrd } from '@/utils/utils';
import CountriesSelect from '@/componentWebs/Common/CountriesSelect';
import FilterCategory from '@/componentWebs/Common/FilterCategory';
import Pagination from '@/componentWebs/Pagination';
import cookie from 'js-cookie';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

moment.locale('vi');

const pageSize = 8;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromValue: null,
      toValue: null,
      currentInd: [],
      currentIndVisaList: [],
      currentIndVisaListMobile: [],
      dataTabsVisa: [],
      type: '',
      dataIntroduse: [],
      currentIndDetail: [],
      currentIndXemThem: [],
      activeTabs: '',
      pagi: {},
      paramState: {},
      textCountries: props.textCountries || '',
      hideNav: null,
      isSearch: props.isSearch,
      range: [0, pageSize - 1],
      countriesId: props.diaDiem || [],
      key: Math.random(),
    };
  }

  // this.refs = list.reduce((acc, value) => {
  //   acc[value.id] = React.createRef();
  //   return acc;
  // }, {});

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'webs/fetchTravelVisaPackageGroups',
      payload: {
        filter: {
          status: '1',
        },
      },
      callback: res => {
        if (res.success) {
          if (res.result.list.length) {
            const dataTabsVisa = (res && res.result && res.result.list) || [];
            this.setState({
              dataTabsVisa,
            });
          }
        }
      },
    });

    this.fetch();

    window.addEventListener('resize', this.resize.bind(this), { passive: true });
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  resize() {
    this.setState({ hideNav: window.innerWidth < 767 });
  }

  // fetch = param => {
  //   const { dispatch } = this.props;

  //   dispatch({
  //     type: 'webs/fetchTravelVisa',
  //     payload: param,
  //     callback: res => {
  //       if (res.success) {
  //         if (res.result && res.result.list && res.result.list.length > 0) {
  //           const dataIntroduse = (res && res.result && res.result.list) || [];
  //           this.setState({
  //             dataIntroduse,
  //           });
  //         }
  //         this.setState({
  //           paramState: param
  //         })
  //       }
  //     },
  //   });
  // };

  fetch = () => {
    const { dispatch } = this.props;
    const {
      fromValue,
      toValue,
      range,

      activeTabs,
      currentInd,
      countriesId,
    } = this.state;

    const tfilter = {
      status: '1',
      travelVisaPackagesStatus: '1',
      travelVisaPackagesDealPrice: [fromValue, toValue],
      travelVisaPackageGroups: currentInd,
      countries: countriesId,
    };

    if ((!fromValue && fromValue !== 0) || (!toValue && toValue !== 0))
      delete tfilter.travelVisaPackagesDealPrice;

    if (!currentInd || (currentInd && currentInd.length === 0))
      delete tfilter.travelVisaPackageGroups;
    if (!countriesId || (countriesId && countriesId.length === 0)) delete tfilter.countries;

    const queryString = {
      filter: tfilter,
      range,
      sort: ['travelVisaPackagesDealPrice', activeTabs === '1' ? 'ASC' : 'DESC'],
    };

    if (!activeTabs) delete queryString.sort;

    dispatch({
      type: 'webs/fetchTravelVisa',
      payload: queryString,
      callback: res => {
        if (res.success) {
          if (res.result && res.result.list) {
            const dataIntroduse = res.result.list || [];
            this.setState({
              dataIntroduse,
              pagi: (res && res.result && res.result.pagination) || {},
            });
          }
        }
      },
    });
  };

  handleClickToggle = ind => {
    const { currentInd } = this.state;
    const newState = [...currentInd];
    // this.fetch(param)
    if (currentInd.includes(ind)) {
      newState.splice(currentInd.indexOf(ind), 1);
    } else {
      newState.push(ind);
    }

    this.setState(
      {
        currentInd: newState,
      },
      () => {
        this.fetch();
      }
    );
  };

  // Xet active tab
  setActiveTab = (active, idVisaList) => {
    const { currentIndVisaList, hideNav, currentIndVisaListMobile } = this.state;

    if (!hideNav) {
      let newCurrentVisaList = [...currentIndVisaList];
      const ind = currentIndVisaList.findIndex(x => x.id === idVisaList);

      if (ind !== -1) {
        if (newCurrentVisaList[ind].active === active) {
          newCurrentVisaList = newCurrentVisaList.filter(x => x.id !== idVisaList);
        } else {
          newCurrentVisaList[ind] = { ...newCurrentVisaList[ind], active };
        }
      } else {
        newCurrentVisaList.push({
          id: idVisaList,
          active,
        });
      }

      this.setState({
        currentIndVisaList: newCurrentVisaList,
      });
    } else {
      // Mobile
      let newCurrentIndVisaListMobile = [...currentIndVisaListMobile];
      if (currentIndVisaListMobile.includes(`${active}_${idVisaList}`)) {
        newCurrentIndVisaListMobile = newCurrentIndVisaListMobile.filter(
          x => x !== `${active}_${idVisaList}`
        );
      } else {
        newCurrentIndVisaListMobile.push(`${active}_${idVisaList}`);
      }

      this.setState({
        currentIndVisaListMobile: newCurrentIndVisaListMobile,
      });
    }
  };

  handleActive = (id, tab) => {
    const { currentIndVisaList, hideNav, currentIndVisaListMobile } = this.state;

    if (!hideNav) {
      const ind = currentIndVisaList.findIndex(x => x.id === id);

      if (ind !== -1) {
        if ((currentIndVisaList[ind] && currentIndVisaList[ind].active) === tab) return 'active';
      }

      return '';
    } else {
      if (currentIndVisaListMobile.includes(`${tab}_${id}`)) return 'active';
      return '';
    }
  };
  handleClassNameActive = item => {
    const { currentIndVisaList, hideNav, currentIndVisaListMobile } = this.state;
    if (!hideNav) {
      if (currentIndVisaList && currentIndVisaList.length === 0) return 'active';

      const ind = currentIndVisaList.findIndex(x => x.id === item.id);

      if (ind !== -1) {
        return 'active';
      }

      return '';
    } else {
      if (currentIndVisaListMobile && currentIndVisaListMobile.length === 0) return 'active';
      const ind = currentIndVisaListMobile.filter(x => x.indexOf(item.id) !== -1);
      if (ind && ind.length > 0) return 'active';

      return '';
    }
  };

  handleCurrent = (ind, stateName) => {
    this.setState(existingState => {
      if (existingState[stateName].includes(ind)) {
        const newState = [...existingState[stateName]];
        newState.splice(existingState[stateName].indexOf(ind), 1);
        return { [stateName]: newState };
      }

      return { [stateName]: [ind, ...existingState[stateName]] };
    });
  };

  handlePackageDetail = (e, itemId, packId) => {
    if (e) e.stopPropagation();

    const ind = `${itemId}_${packId}`;

    const { currentIndDetail } = this.state;

    const newState = [...currentIndDetail];
    // this.fetch(param)
    if (currentIndDetail.includes(ind)) {
      newState.splice(currentIndDetail.indexOf(ind), 1);
    } else {
      newState.push(ind);
    }
    this.setState({
      currentIndDetail: newState,
    });

    // this.handleCurrent(ind, 'currentIndDetail');
  };

  xemThemGoiDichVU = ind => {
    this.handleCurrent(ind, 'currentIndXemThem');
  };

  handleXemThemArr = (arr, id) => {
    const { currentIndXemThem } = this.state;
    let newArr = [...arr];

    if (!currentIndXemThem.includes(id)) newArr = newArr.slice(0, 4);

    return newArr;
  };

  filterPrice = tab => {
    const { visible } = this.state;

    this.setState(
      {
        activeTabs: tab,
        visible: !visible,
      },
      () => {
        this.fetch();
      }
    );
  };

  onAfterChange = value => {
    this.setState(
      {
        fromValue: value[0],
        toValue: value[1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleCountries = value => {
    this.setState(
      {
        countriesId: value,
      },
      () => {
        this.fetch();
      }
    );
  };

  handleChangePagi = currentPagesss => {
    const { paramState } = this.state;
    const indexOfLastNews = currentPagesss * pageSize; // vị trí của tin cuối cùng trong list được hiển thị
    const indexOfFirstNews = indexOfLastNews - pageSize;

    this.setState(
      {
        range: [indexOfFirstNews, indexOfLastNews - 1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleClear = () => {
    const { visible, isSearch } = this.state;

    if (isSearch) {
      this.setState(
        {
          currentInd: [],
          // countriesId: [],
          fromValue: null,
          toValue: null,
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
        },
        () => this.fetch()
      );
    } else {
      this.setState(
        {
          currentInd: [],
          countriesId: [],
          fromValue: null,
          toValue: null,
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
        },
        () => this.fetch()
      );
    }
  };

  handleClickDat = item => {
    // const totalPrice = this.handleTotoal();

    const newData = {
      travelVisaPackageName: item.travelVisaPackageName,
      dealPrice: item.travelVisaPackagesDealPrice,
      serviceCode: 'VISA',
    };

    // notification

    cookie.remove('saveDataBooking');
    const date = new Date();
    const minutes = 30;
    date.setTime(date.getTime() + minutes * 60 * 1000);
    cookie.set('saveDataBooking', newData, { expires: date });
    window.location.href = `/checkout?booking=VISA`;
  };

  render() {
    const { data, mobile, isQuestion, imageResize } = this.props;
    const {
      fromValue,
      toValue,
      dataTabsVisa,
      currentInd,
      dataIntroduse,
      currentIndDetail,
      currentIndVisaList,
      currentIndXemThem,
      activeTabs,
      pagi,
      type,
      visible,
      countriesId,
      key,
      textCountries,
      hideNav,
    } = this.state;
    // console.log("textCountries: ", textCountries);

    const boloc = (
      <div className="datVeMayBay__filter-box">
        <div className="datVeMayBay__filter-box__header flex-b-c">
          <div className="title" onClick={() => this.setState({ visible: !visible })}>
            Bộ lọc
          </div>
          <div className="clear" onClick={this.handleClear} style={{ cursor: 'pointer' }}>
            Xóa lọc
          </div>
        </div>
        <div className="datVeMayBay__filter-box__main">
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Khoảng giá</div>
            <div className="wrapper_silder-title">
              <p className="slider-title flex-b-c">
                <span id="min">{fromValue ? formatNumber(fromValue * 1) : 0}₫</span>
                <span id="max">
                  {toValue ? formatNumber(toValue ? toValue * 1 : 50000000) : 50000000}₫
                </span>
              </p>
              <Slider
                className="slider-track-custom"
                range
                step={100000}
                defaultValue={[0, 50000000]}
                value={[fromValue || 0, toValue || 50000000]}
                min={0}
                max={50000000}
                tooltipVisible={false}
                onChange={value =>
                  this.setState({
                    fromValue: value[0],
                    toValue: value[1],
                  })
                }
                onAfterChange={this.onAfterChange}
              />
            </div>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Loại dịch vụ</div>
            <ul className="datVeMayBay__filter-box__checkbox">
              {dataTabsVisa &&
                dataTabsVisa.length > 0 &&
                dataTabsVisa.map(item => (
                  <li
                    className="datVeMayBay__filter-box__checkbox__item"
                    key={item.id}
                    onClick={() => this.handleClickToggle(Number(item.id))}
                  >
                    <div className="checkbox">
                      {currentInd.includes(Number(item.id)) && <i className="fas fa-check" />}
                    </div>
                    <div className="text">{item.travelVisaPackageGroupName}</div>
                  </li>
                ))}
            </ul>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Điểm đến của bạn</div>

            <div className="wrapper_silder-title">
              <CountriesSelect
                placeholder="Chọn nước bạn muốn làm dịch vụ"
                filter
                onChange={this.handleCountries}
                key={key}
                value={countriesId}
                text={textCountries}
              />
            </div>
          </div>

          <div
            className="datVeMayBay__filter-box__rectangle hidden-pc"
            style={{ borderBottom: 'none' }}
          >
            <button
              className="btn box-product__btn btnapdung hidden-pc"
              type="button"
              onClick={() => this.setState({ visible: !visible })}
            >
              <span>Áp dụng</span>
            </button>
          </div>
        </div>
      </div>
    );

    const sort = (
      <ul className="datVeMayBay__right-filter__list sortMobile flex-a-c">
        {/* <li className="active">
            <span>Giảm giá sâu</span>
            <i className="fas fa-times" />
          </li> */}
        <li className={activeTabs === '1' && 'active'}>
          <span onClick={() => this.filterPrice('1')}>Giá thấp nhất</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
        <li className={activeTabs === '2' && 'active'}>
          <span onClick={() => this.filterPrice('2')}>Giá giảm dần</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
      </ul>
    );

    // const template =
    //   data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    // const imageResize =
    //   template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;

    return (
      // Tin tức trang chủ
      <React.Fragment>
        <div className="khachSan-products visa-products-wrapper">
          <div className="row boloc hidden-pc visa-boloc">
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '1' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon feather-filter.svg"
                alt=""
                className="lazyload"
              />
              Bộ lọc
            </div>
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '2' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon awesome-sort-amount-down.svg"
                alt=""
                className="lazyload"
              />
              Sắp xếp
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 hidden-m-t">
              {isQuestion && (
                <div className="box-visa-question-near-sort hidden-m-t">
                  <img src="/static/vietnamTickets/images/NoPath - Copy (3).jpg" />
                  <div className="visa_question__box ">
                    <div className="text">Bạn cần tư vấn về dịch vụ visa ?</div>
                    <div className="phone">
                      Gọi Ngay{' '}
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => (window.location.href = `tel:${mobile}`)}
                      >
                        {mobile}
                      </span>
                    </div>
                    <div
                      className="btn-kiemtra flex-center"
                      onClick={() => {
                        const { visibleQuestionL } = this.props;
                        if (visibleQuestionL) visibleQuestionL();
                      }}
                    >
                      Kiểm tra tỷ lệ đậu
                    </div>
                  </div>
                </div>
              )}

              {boloc}
            </div>
            <div className="col-lg-9">
              <div className="khachSan-products__wrapper visa-product__wrapper">
                {/* O filter  */}
                <div className="datVeMayBay__right-filter khachSan__right-filter flex-b-c hidden-m-t">
                  {sort}
                </div>
                {/* lisst  */}
                <ul className="visa-product__list">
                  {dataIntroduse &&
                    dataIntroduse.length > 0 &&
                    dataIntroduse.map(item => (
                      <li
                        className={`visa-product__item ${this.handleClassNameActive(item)}`}
                        key={item.id}
                      >
                        <div className="visa-product__info flex-b-c">
                          <div className="visa-product__name flex-a-c">
                            <img
                              src={`${(item.countries &&
                                item.countries.images &&
                                item.countries.images[0] &&
                                item.countries.images[0].file &&
                                getResponsiveImage(item.countries.images[0].file, imageResize)) ||
                                '/static/vietnamTickets/images/unimage.png'}`}
                              alt={item.countries && item.countries.countrieName}
                              className="lazyload"
                            />
                            <div className="visa-product__name__wrapper ">
                              <span className="text">{item.travelVisaName}</span>

                              <div className="visa-product__price-detail hidden-pc">
                                <span className="title">Giá chỉ từ:</span>
                                {formatNumber(item.travelVisaPackagesDealPrice)}đ
                                <span className="luot">/ lượt</span>
                              </div>
                            </div>
                          </div>
                          <div className="visa-product__price flex-a-c">
                            <div className="visa-product__price-detail hidden-m-t">
                              <span className="title">Giá chỉ từ:</span>
                              {formatNumber(item.travelVisaPackagesDealPrice)}đ
                              <span className="luot">/ lượt</span>
                            </div>
                            <div
                              className="visa-product__select flex-center hidden-m-t"
                              onClick={() => this.setActiveTab('3', item.id)}
                            >
                              <span className="text">Chọn gói</span>
                              <i className="fas fa-angle-down" />
                            </div>
                          </div>
                        </div>
                        <ul
                          className={
                            currentIndVisaList && currentIndVisaList.length > 0
                              ? 'visa-product__tabs-header active flex-a-c'
                              : 'visa-product__tabs-header flex-a-c'
                          }
                        >
                          <li
                            onClick={() => this.setActiveTab('1', item.id)}
                            className={`list-visa ${this.handleActive(item.id, '1')}`}
                          >
                            <div className="wrapper-tabs-header">
                              <span>Giới thiệu dịch vụ</span>
                              {this.handleActive(item.id, '1') === 'active' ? (
                                <i className="fas fa-angle-up hidden-pc hidden-t" />
                              ) : (
                                <i className="fas fa-angle-down hidden-pc hidden-t" />
                              )}
                            </div>

                            {this.handleActive(item.id, '1') === 'active' && (
                              <div className="visa-product__tabs visa-product__tabs-mobile hidden-pc hidden-t">
                                <div className="visa-product__tabs-gioithieu hidden-pc">
                                  {item.travelVisaDescriptions ? (
                                    <div
                                      className="ck-content"
                                      dangerouslySetInnerHTML={{
                                        __html: item.travelVisaDescriptions,
                                      }}
                                    />
                                  ) : (
                                    <Tag className="Tag_custom" color="#EB0281">
                                      Chưa có nội dung
                                    </Tag>
                                  )}
                                </div>
                              </div>
                            )}
                          </li>
                          <li
                            onClick={() => this.setActiveTab('2', item.id)}
                            className={`list-visa ${this.handleActive(item.id, '2')}`}
                          >
                            <div className="wrapper-tabs-header">
                              <span>Quy trình làm việc</span>
                              {this.handleActive(item.id, '2') === 'active' ? (
                                <i className="fas fa-angle-up hidden-pc hidden-t" />
                              ) : (
                                <i className="fas fa-angle-down hidden-pc hidden-t" />
                              )}
                            </div>
                            {this.handleActive(item.id, '2') === 'active' && (
                              <div className="visa-product__tabs visa-product__tabs-mobile hidden-pc hidden-t">
                                <div className="visa-product__tabs-gioithieu hidden-pc">
                                  {item.travelVisaWorkFlow ? (
                                    <div
                                      className="ck-content"
                                      dangerouslySetInnerHTML={{
                                        __html: item.travelVisaWorkFlow,
                                      }}
                                    />
                                  ) : (
                                    <div className="content">
                                      <Tag className="Tag_custom" color="#EB0281">
                                        Chưa có nội dung
                                      </Tag>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </li>
                          <li
                            onClick={() => this.setActiveTab('3', item.id)}
                            className={`list-visa ${this.handleActive(item.id, '3')}`}
                          >
                            <div className="wrapper-tabs-header">
                              <span>Gói dịch vụ</span>
                              {this.handleActive(item.id, '3') === 'active' ? (
                                <i className="fas fa-angle-up hidden-pc hidden-t" />
                              ) : (
                                <i className="fas fa-angle-down hidden-pc hidden-t" />
                              )}
                            </div>
                            {this.handleActive(item.id, '3') === 'active' && (
                              <div className="visa-product__tabs visa-product__tabs-mobile hidden-pc hidden-t">
                                <div className="visa-product__tabs__packages hidden-pc">
                                  <ul className="visa-product__tabs__packages-list">
                                    {item.travelVisaPackages &&
                                      item.travelVisaPackages.length > 0 &&
                                      this.handleXemThemArr(item.travelVisaPackages, item.id).map(
                                        pack => (
                                          <li key={pack.id}>
                                            <div className="wrapper_visa-packages-item flex-b-c">
                                              <div className="visa-package__title flex-a-c">
                                                <div className="text">
                                                  {pack.travelVisaPackageName}
                                                </div>

                                                {/* // Mobile  */}
                                                <i
                                                  className="fas fa-info-circle "
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={e =>
                                                    this.handlePackageDetail(e, item.id, pack.id)
                                                  }
                                                />
                                                <a
                                                  className="hidden-m-t"
                                                  onClick={e =>
                                                    this.handlePackageDetail(e, item.id, pack.id)
                                                  }
                                                >
                                                  {!currentIndDetail.includes(
                                                    `${item.id}_${pack.id}`
                                                  )
                                                    ? 'Xem chi tiết'
                                                    : 'Thu gọn'}
                                                </a>
                                              </div>
                                              <div className="visa-package__price flex-a-c">
                                                <div className="price">
                                                  {formatNumber(pack.travelVisaPackagesDealPrice)}đ
                                                </div>
                                                <div
                                                  className="hidden-pc btn-product-visa-mobile"
                                                  onClick={() => this.handleClickDat(pack)}
                                                >
                                                  <span>Đặt ngay</span>
                                                  <i className="fas fa-long-arrow-alt-right" />
                                                </div>
                                                <button
                                                  className="btn box-product__btn flex-a-c hidden-m-t"
                                                  type="button"
                                                  onClick={() => this.handleClickDat(pack)}
                                                >
                                                  <span>Đặt ngay</span>
                                                  <i className="fas fa-long-arrow-alt-right" />
                                                </button>
                                              </div>
                                            </div>
                                            {currentIndDetail.includes(`${item.id}_${pack.id}`) && (
                                              <div className="visa-packages-item__detail">
                                                {pack.travelVisaPackageDescriptions ? (
                                                  <div
                                                    className="ck-content"
                                                    dangerouslySetInnerHTML={{
                                                      __html: pack.travelVisaPackageDescriptions,
                                                    }}
                                                  />
                                                ) : (
                                                  <div className="content">
                                                    <Tag className="Tag_custom" color="#EB0281">
                                                      Chưa có nội dung
                                                    </Tag>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </li>
                                        )
                                      )}
                                  </ul>
                                  {item.travelVisaPackages && item.travelVisaPackages.length > 4 && (
                                    <a
                                      onClick={() => this.xemThemGoiDichVU(item.id)}
                                      className="xemThem"
                                    >
                                      <span>
                                        {!currentIndXemThem.includes(item.id)
                                          ? 'Xem thêm'
                                          : 'Thu gọn'}
                                      </span>
                                      <i className="fas fa-angle-down" />
                                    </a>
                                  )}
                                </div>
                              </div>
                            )}
                          </li>
                          <li
                            className='list-visa'
                            onClick={() => {
                              const { visibleQuestionL } = this.props;
                              if (visibleQuestionL) visibleQuestionL();
                            }}
                          >
                            <div className="wrapper-tabs-header">
                              <span> Kiểm tra tỷ lệ đậu</span>
                            </div>
                          </li>
                        </ul>
                        {currentIndVisaList && currentIndVisaList.length > 0 && (
                          <div className="visa-product__tabs hidden-m">
                            {/* Tabs gioi thieu */}
                            {this.handleActive(item.id, '1') === 'active' && (
                              <div className="visa-product__tabs-gioithieu hidden-m">
                                {item.travelVisaDescriptions ? (
                                  <div
                                    className="ck-content"
                                    dangerouslySetInnerHTML={{
                                      __html: item.travelVisaDescriptions,
                                    }}
                                  />
                                ) : (
                                  <Tag className="Tag_custom" color="#EB0281">
                                    Chưa có nội dung
                                  </Tag>
                                )}
                              </div>
                            )}
                            {/* Tabs quy trinh */}

                            {this.handleActive(item.id, '2') === 'active' && (
                              <div className="visa-product__tabs-gioithieu hidden-m">
                                {item.travelVisaWorkFlow ? (
                                  <div
                                    className="ck-content"
                                    dangerouslySetInnerHTML={{
                                      __html: item.travelVisaWorkFlow,
                                    }}
                                  />
                                ) : (
                                  <div className="content">
                                    <Tag className="Tag_custom" color="#EB0281">
                                      Chưa có nội dung
                                    </Tag>
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Tab goi dich vuj  */}
                            {this.handleActive(item.id, '3') === 'active' && (
                              <div className="visa-product__tabs__packages hidden-m">
                                <ul className="visa-product__tabs__packages-list">
                                  {item.travelVisaPackages &&
                                    item.travelVisaPackages.length > 0 &&
                                    this.handleXemThemArr(item.travelVisaPackages, item.id).map(
                                      pack => (
                                        <li key={pack.id}>
                                          <div className="wrapper_visa-packages-item flex-b-c">
                                            <div className="visa-package__title flex-a-c">
                                              <div className="text">
                                                {pack.travelVisaPackageName}
                                              </div>
                                              <a
                                                onClick={e =>
                                                  this.handlePackageDetail(e, item.id, pack.id)
                                                }
                                              >
                                                {!currentIndDetail.includes(`${item.id}_${pack.id}`)
                                                  ? 'Xem chi tiết'
                                                  : 'Thu gọn'}
                                              </a>
                                            </div>
                                            <div className="visa-package__price flex-a-c">
                                              <div className="price">
                                                {formatNumber(pack.travelVisaPackagesDealPrice)}đ
                                              </div>
                                              <button
                                                className="btn box-product__btn flex-a-c"
                                                type="button"
                                                onClick={() => this.handleClickDat(pack)}
                                              >
                                                <span>Đặt ngay</span>
                                                <i className="fas fa-long-arrow-alt-right" />
                                              </button>
                                            </div>
                                          </div>
                                          {currentIndDetail.includes(`${item.id}_${pack.id}`) && (
                                            <div className="visa-packages-item__detail">
                                              {pack.travelVisaPackageDescriptions ? (
                                                <div
                                                  className="ck-content"
                                                  dangerouslySetInnerHTML={{
                                                    __html: pack.travelVisaPackageDescriptions,
                                                  }}
                                                />
                                              ) : (
                                                <div className="content">
                                                  <Tag className="Tag_custom" color="#EB0281">
                                                    Chưa có nội dung
                                                  </Tag>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </li>
                                      )
                                    )}
                                </ul>
                                {item.travelVisaPackages && item.travelVisaPackages.length > 4 && (
                                  <a
                                    onClick={() => this.xemThemGoiDichVU(item.id)}
                                    className="xemThem"
                                  >
                                    <span>
                                      {!currentIndXemThem.includes(item.id)
                                        ? 'Xem thêm'
                                        : 'Thu gọn'}
                                    </span>
                                    <i className="fas fa-angle-down" />
                                  </a>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </li>
                    ))}
                </ul>

                {/* {dataIntroduse && dataIntroduse.length > 19 && (
                  <Pagination
                    style={{ textAlign: 'right', marginTop: '20px' }}
                    onChange={this.handleChangePagi}
                    current={pagi && pagi.current}
                    total={pagi && pagi.total}
                    pageSize={pageSize}
                  />
                )} */}
                {pagi.total > pageSize - 1 && (
                  <Pagination
                    style={{ textAlign: 'right', marginTop: '20px' }}
                    onChange={this.handleChangePagi}
                    current={pagi && pagi.current}
                    total={pagi && pagi.total}
                    pageSize={pageSize}
                  />
                )}
              </div>
            </div>
          </div>

          {/* <div className="pagiTuyenBay-top hidden-pc" /> */}
        </div>
        {hideNav && (
          <FilterCategory visibleDrawer={visible} type={type}>
            {type === '1' && boloc}
            {type === '2' && sort}
          </FilterCategory>
        )}
      </React.Fragment>
    );
  }
}

export default Index;
